import Script from "next/script";

const CustomScript = () => {
  return (
    <>
      <Script
        id="ze-snippet"
        strategy="afterInteractive"
        src={
          "https://static.zdassets.com/ekr/snippet.js?key=332a0557-421a-4fb8-8d2e-a4ca8abef06d"
        }
      />

      <Script
        strategy="beforeInteractive"
        src={process.env.NEXTAUTH_URL + "/scripts/kaltura-ovp-player.js"}
      />

      <Script
        id="fb-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '847847980429258');
            fbq('track', 'PageView');
          `,
        }}
      />
    </>
  );
};

export default CustomScript;
